// Players Health brand palette — single source of truth for JS/inline styles.
// Mirrors backend/brand.py and the CSS variables in index.css. Keep in sync.
export const BRAND = {
  violet: "#6B5CE7", // primary brand
  teal: "#4ECDC4", // secondary brand
  accentPurple: "#7B6FE8", // eyebrows / chips / accent
  productTeal: "#4CD6BE", // primary CTA / "live" status
  warmGold: "#F2B65A", // warning / document accent
  magenta: "#F25C8E", // warm gradient / person accent
  coverDark: "#232323", // dark surface
};

export const DEFAULT_ENTITY_COLOR = BRAND.violet;

export const CATEGORY_COLORS = {
  "All conversations": BRAND.violet,
  Email: BRAND.teal,
  Meeting: BRAND.accentPurple,
  Document: BRAND.warmGold,
  Person: BRAND.magenta,
  "Topic / Strategy": BRAND.violet,
};

// rgba helper for tinted backgrounds/borders from a brand hex.
export function brandRgba(hex, alpha = 1) {
  const h = hex.replace("#", "");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
